import React, { useEffect } from 'react';
import Card from '../Card/Card';
import { Form, Tooltip } from 'antd';
import DropdownSelect from '../../../../components/dropdownSelect';
import { getRenderControl } from '../../../../components/SingleControlCustom/getRenderControl';
import { getDocOptionsWorkersSelect } from '../../utils/getDocOptionsSelect';
import useExecuterListQuery from '../../queries/useExecuterListQuery';
import useWorkersListQuery from '../../queries/useWorkersListQuery';
import { useSelector } from 'react-redux';
import { documentDrawerSelector } from '../../store/selectors/new-document.selector';
import { ReactComponent as RelatedObjectIcon } from '../../../../resource/RelatedObjectIcon.svg';

const ResponsiblePersonsContainer = ({ form }) => {
  const { getFieldDecorator, getFieldValue, resetFields } = form;

  const { mode } = useSelector(documentDrawerSelector);

  const isEditMode = mode === 'edit';

  const serviceCompanyIdValue = getFieldValue('serviceCompanyId');

  const isDisabled = !serviceCompanyIdValue && mode === 'create';

  const { data: executerList = [], isFetching: isExecuterFetching } =
    useExecuterListQuery(
      { serviceCompanyId: serviceCompanyIdValue },
      { enabled: Boolean(serviceCompanyIdValue) }
    );
  const { data: workersList = [], isFetching: isWorkersFetching } =
    useWorkersListQuery(
      { serviceCompanyId: serviceCompanyIdValue },
      { enabled: Boolean(serviceCompanyIdValue) }
    );

  useEffect(() => {
    if (!!isEditMode) return;

    resetFields(['ResponsibleWorkerId', 'executerIds']);
  }, [serviceCompanyIdValue]);

  return (
    <Card
      heading="Ответственные лица"
      icon={<RelatedObjectIcon />}
    >
      <div>
        <Form.Item
          label="Ответственный"
          style={{ margin: 0 }}
        >
          <Tooltip
            title={
              isDisabled ? 'Укажите компанию, чтобы выбрать ответсвенного' : ''
            }
          >
            <div>
              {getFieldDecorator('ResponsibleWorkerId', {
                rules: [
                  {
                    required: true,
                    message: 'Пожалуйста, укажите ответсвенного',
                  },
                ],
              })(
                <DropdownSelect
                  disabled={isWorkersFetching || !serviceCompanyIdValue}
                  loading={isWorkersFetching}
                  options={getDocOptionsWorkersSelect(workersList)}
                  multiple={false}
                  renderControl={getRenderControl({
                    options: getDocOptionsWorkersSelect(workersList),
                    value: getFieldValue('ResponsibleWorkerId'),
                    placeholder: 'Ответственный',
                    disabled: isWorkersFetching || !serviceCompanyIdValue,
                  })}
                />
              )}
            </div>
          </Tooltip>
        </Form.Item>

        <Form.Item
          label="Исполнители"
          style={{ margin: 0 }}
        >
          <Tooltip
            title={
              isDisabled ? 'Укажите компанию, чтобы выбрать исполнителей' : ''
            }
          >
            <div>
              {getFieldDecorator('executerIds')(
                <DropdownSelect
                  disabled={isExecuterFetching || !serviceCompanyIdValue}
                  loading={isExecuterFetching}
                  options={getDocOptionsWorkersSelect(executerList)}
                  multiple={true}
                  label="Исполнители"
                />
              )}
            </div>
          </Tooltip>
        </Form.Item>
      </div>
    </Card>
  );
};

export default ResponsiblePersonsContainer;
